module.exports = __webpack_public_path__ + "static/img/ma5.cbc489d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma5.gif
// module id = RHVu
// module chunks = 1